import { render } from "./g10POSTranData.vue?vue&type=template&id=67991a36"
import script from "./g10POSTranData.vue?vue&type=script&lang=js"
export * from "./g10POSTranData.vue?vue&type=script&lang=js"

import "./g10POSTranData.vue?vue&type=style&index=0&id=67991a36&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__